export const environment = {
  production: true,
  domainName: 'dev'
};
